




















































































import { Component, Vue } from "vue-property-decorator";
import Country from "@/store/entities/country";
@Component({})
export default class AddCountry extends Vue {
  dialog: boolean = true;
 
  country: Country = new Country();
  isEdit: boolean = false;
  isValid: boolean = false;

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
        dropdown: (value) => !!value.id || "Zorunlu Alan.",
      },
    };
  }

  async created() {
   

    this.country = this.$store.state.country.editCountry;
    if (this.country == null) {
      this.isEdit = false;
      this.country = new Country();
    } else {
      this.isEdit = true;
   
    }
  }

  async saveCountry() {
    this.country.id = this.country.id;
    this.country.code=this.country.id
    this.country.name=this.country.name;

    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "country/saveCountry",
        data: this.country,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "country/saveCountry",
        data: this.country,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }



  

  closeDialog() {
    this.$emit("closed");
    this.$store.state.country.editCountry = null;
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.country.editCountry = null;
  }
}
